import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, Typography } from "@mui/material";
import { syncDatabase } from "../utils/offlineSync";
import pageStyle from "./LoginPage.module.css";

function AuthPage() {
  const [searchParams] = useSearchParams();
  const to = searchParams.get("to") || "/";

  const { isLoading, getAccessTokenSilently, user } = useAuth0();
  const nav = useNavigate();
  const [status, setStatus] = useState("Signing in…");

  useEffect(() => {
    if (isLoading) {
      return;
    }
    // set the token
    getAccessTokenSilently()
      .then((token) => {
        // set token
        localStorage.setItem("token", token);
        localStorage.setItem("username", user?.name || "");
        setStatus("Loading your data…");
        // Forward to the application once the first sync finishes. If it
        // fails, go in anyway: the app retries syncing in the background.
        syncDatabase(token)
          .catch(() => {})
          .finally(() => nav(to));
      })
      .catch(() => {
        nav("/login");
      });
  }, [isLoading, getAccessTokenSilently, nav, to]);

  return (
    <div className={pageStyle.loginContainer}>
      <CircularProgress />
      <Typography color="text.secondary">{status}</Typography>
    </div>
  );
}

export default AuthPage;
